import React from 'react';
import ModelViewerWithCustomPath from 'src/components/modelViewerWithCustomPath/modelViewerWithCustomPath';
import ModelViewerWithCustomPathLayout from 'src/components/modelViewerWithCustomPath/modelViewerWithCustomPath-layout';


const ModelViewerWithCustomPathPage: React.FC = () => {
  return (
    <ModelViewerWithCustomPathLayout children={<ModelViewerWithCustomPath/>}></ModelViewerWithCustomPathLayout>
  );
};

export default ModelViewerWithCustomPathPage;